module.exports = __webpack_public_path__ + "static/media/Employee_Census_Template.1d912438.xlsx";